import TemplatePageFooter from '@anm/components/templates/TemplatePageFooter';
import { VideoTemplatesPageContext } from '@anm/contexts/VideoTemplatesPageContext';
import { useContext, FC } from 'react';

import { LayoutProvider } from '../../layouts/Layout';
import VideoTemplatesLayout from '../../layouts/VideoTemplatesLayout';
import PageContent from '../PageContent';

export type VideoTemplatesSectionProps = { isNavigation?: boolean; isFooter?: boolean };

const VideoTemplatesSection: FC<VideoTemplatesSectionProps> = ({ isNavigation, isFooter }) => {
  const { pageName } = useContext(VideoTemplatesPageContext);

  return (
    <LayoutProvider value={{ isNavigation, isFooter }}>
      <VideoTemplatesLayout navigationVariant="white">
        <PageContent {...{ pageName }} />
        <TemplatePageFooter {...{ pageName }} />
      </VideoTemplatesLayout>
    </LayoutProvider>
  );
};

export default VideoTemplatesSection;
